import * as tslib_1 from "tslib";
import * as searchActions from './search/actions';
import * as hotelActions from './hotel/actions';
import * as packageActions from './package/actions';
import * as railPackageActions from './railPackage/actions';
var coreActions = tslib_1.__assign({}, searchActions, hotelActions, packageActions, railPackageActions);
export { coreActions };
